import { getCampaignSASuggestions } from 'app/sponsoredAds/services/autosuggestServices';
import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';
import withMultiSelectAutosuggest from './withMultiSelectAutosuggest';

const CampaignAutosuggestSA = autosuggestFactory({
   apiPromise: getCampaignSASuggestions,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabel,
   defaultPlaceholder: 'Search Campaign...',
});

export default withAutosuggestWrapper(withInputErrorMessage(CampaignAutosuggestSA));
export const CampaignMultiSelectSA = withMultiSelectAutosuggest(CampaignAutosuggestSA);
